
const rotate = {
    title: '云端旅博---云上逛旅博，带您游天下',
    name: 'AI',
    desc: '数字展厅',
    btn: {
        desc: '展馆',
        prev: '上一个',
        next: '下一个',
        enter: '点击进入云会展'
    },

    bannerList:[{
        name: '安逸四川展区',
        url: '/vr1',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-02.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/01.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-01.png?imageMogr2/thumbnail/150x',
    },{
        name: '城市礼物展区',
        url: '/vr3',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-01.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/02.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-02.png?imageMogr2/thumbnail/150x',
    },{
        name: '旅游目的地融合展区',
        url: '/vr4',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-03.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/03.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-03.png?imageMogr2/thumbnail/150x',
    },{
        name: '文化旅游新技术应用展',
        url: '/vr5',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-05.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/04.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-04.png?imageMogr2/thumbnail/150x',
    },{
        name: '文旅中国创新展馆',
        url: '/vr2',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-04.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/05.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-05.png?imageMogr2/thumbnail/150x',
    }],
    navs: [{
        name: 'AI场馆',
        isActive: true,
        url: './'
      },{
        name: '云直播',
        isActive: false,
        url: 'http://qr28.cn/BLpEoA'
      },{
        name: '云交易',
        isActive: false,
        url: 'https://thenextravelmarket.com/vptm2020'
      },{
        name: '云发布',
        isActive: false,
        url: 'https://www.henglvwang.cn/list-221-1.html'
      }],
    copyright: '版权所有：四川国际旅游交易博览会ICP备案/许可证号：蜀ICP备19027923号',
    ask: {
        robot:'点击为您解答',
        title: '点击查询相关信息',
        list:[{
          key: '大会简介',
          q: '大会简介',
          a: '四川国际旅游交易博览会创办于2014年，每年秋季在乐山市峨眉山市举办，迄今已成功举办六届。四川国际旅游交易博览会是目前中国西部地区最具规模和行业影响力的文化旅游产业交易博览会，是国际文化旅游行业展示旅游形象，推动旅游合作的重要平台。',
          isSelect: true
        },{
          key: '展馆地址',
          q: '展馆地址',
          a: '第七届四川国际旅游交易博览会定于2020年9月25日至28日在四川省乐山市峨眉山市四川国际旅游交易博览中心举行。公共交通：逛展可乘坐动车至峨眉山站转乘峨眉山6路巴士前往展馆；自驾出行：峨眉山市旅博大道与龚海路交叉路口往西南约50米。(水晶广场南侧约100米)',
          isSelect: false
        },{
          key: '开馆时间',
          q: '开馆时间',
          a: '第七届四川国际旅游交易博览会定于2020年9月25日至28日举行。公众开放时间为：9月25日13:30-17:00；9月26日09:00-17:00；9月27日09:00-17:00；9月28日09:00-12:00。',
          isSelect: false
        },{
          key: '票务服务',
          q: '票务服务',
          a: '预约进馆方式：1、通过手机微信关注旅博会官方微信公众号“恒旅网”；2、点击底部菜单栏：“会展服务”；3、点击“票务通”进行预约入馆。（可以预约到场日期与场次）',
          isSelect: false
        }]
      }
}
const vr1 = {
    title: '云端旅博---云上逛旅博，带您游天下',
    return: '返回主馆',
    url: '',
    navs: [{
        name: 'AI场馆',
        isActive: false,
        url: './'
      },{
        name: '云直播',
        isActive: false,
        url: 'http://qr28.cn/BLpEoA'
      },{
        name: '云交易',
        isActive: false,
        url: 'https://thenextravelmarket.com/vptm2020'
      },{
        name: '云发布',
        isActive: false,
        url: 'https://www.henglvwang.cn/list-221-1.html'
      }],
    name: 'VR',
    desc: '展厅',
    d1: '安逸四川展区',
    t1: 'A1、A2馆',
     add: '地址:',
  t2: '5000㎡',
    content: '共设展位18个，参展商500余家，安逸四川展区集中呈现了四川省各市州文旅发展成果，全面展示和推介文化旅游资源。'
}
const vr2 = {
  title: '云端旅博---云上逛旅博，带您游天下',
  return: '返回主馆',
  url: '',
  navs: [{
      name: 'AI场馆',
      isActive: false,
      url: './'
    },{
      name: '云直播',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: '云交易',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: '云发布',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: '展厅',
  d1: '文旅中国创新展区',
  t1: 'A2、A3馆',
   add: '地址:',
  t2: '5000㎡',
  content: '共设展位28个，参展商600余家。文旅中国创新展区全面展示各省市、地区的文旅发展成就和创新成果，精选文旅商品、旅游纪念品、民俗礼品、地方特色食品等文旅精品展出。其中，北京、内蒙古、河南、福建、新疆、贵州、陕西、湖北、甘肃、湖南、川旅投等11个省市和企业进行特装展示，甘肃、山西、黑龙江、青海、广西、安徽、海南、山东、宁夏、辽宁等10个省市和大连博涛文化、湖北智旅云、四川雅睿研学旅行等10家企业参展。'
}
const vr3 = {
  title: '云端旅博---云上逛旅博，带您游天下',
  return: '返回主馆',
  navs: [{
      name: 'AI场馆',
      isActive: false,
      url: './'
    },{
      name: '云直播',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: '云交易',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: '云发布',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: '展厅',
  d1: '城市礼物展区',
  t1: 'B馆',
   add: '地址:',
  t2: '2000㎡',
  content: '共设有展位67个，参展商60余家。城市礼物展区集中展示国际国内顶尖文旅文创作品和旅游商品。国际部分有大英博物馆、大都会博物馆、俄罗斯博物馆等官方文创商品入驻，国内部分有乐山、上海、新疆、江西、福建等5个城市礼物文创产品。同时该展区还设置非遗、文博等相关文创产品和旅游商品，整体展示了目前文创产业的发展活力。'
}
const vr4 = {
  title: '云端旅博---云上逛旅博，带您游天下',
  return: '返回主馆',
  navs: [{
      name: 'AI场馆',
      isActive: false,
      url: './'
    },{
      name: '云直播',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: '云交易',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: '云发布',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: '展厅',
  d1: '旅游目的地融合展厅',
  t1: 'D2馆',
  add: '地址:',
  t2: '3300㎡',
  content: '共设展位6个，参展商近10余家。世界旅游目的地融合展厅根据成渝地区双城经济圈、石刻艺术世界遗产走廊布局，设置成都、重庆、乐山、宜宾四城同馆，融入主宾国柬埔寨、主宾省重庆武隆、大足、南川，集中展示巴蜀文化旅游走廊世界级文旅资源。'
}
const vr5 = {
  title: '云端旅博---云上逛旅博，带您游天下',
  return: '返回主馆',
  url: '',
  navs: [{
      name: 'AI场馆',
      isActive: false,
      url: './'
    },{
      name: '云直播',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: '云交易',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: '云发布',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: '展厅',
  d1: '文化旅游新技术应用展',
  t1: 'F馆',
   add: '地址:',
  t2: '2000㎡',
  content: '文化旅游新技术应用展聚焦全国文旅新业态新产品，参展商10余家，以“新基建、5G、大数据、物联网、区块链”为主题，集中展示文旅新技术应用、“智游天府”、“智游乐山”、文旅新技术小场景，以及智慧厕所、无人驾驶汽车、无人销售、创意飞行设备等文旅新设备，国际旅游云展与旅博现场多链路交互呈现。'
}
const zh = {rotate,vr1,vr2,vr3,vr4,vr5}
export default zh